/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente__A_95_65 as Componente__A_95_65,
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_SelectorFecha as SelectorFecha,
  rec_SelectorMultiple as SelectorMultiple,
  rec_ZC as ZC,
  rec_api as api,
  rec_dS as dS,
  rec_fS as fS,
  rec_ii as ii,
  rec_zo as zo,
  rec_zx as zx,
} from "../../runtime/index.jsx";
export function DesempenoPersonal({
  usuarioId: e,
  rango: t,
  onClose: n,
  onCambio: r,
}) {
  let [i, a] = (0, React.useState)(null),
    [o, s] = (0, React.useState)(``),
    [c, l] = (0, React.useState)(!1),
    [u, f] = (0, React.useState)([]),
    [p, m] = (0, React.useState)(``),
    [h, g] = (0, React.useState)(dS(new Date())),
    [_, v] = (0, React.useState)(``),
    y = (0, React.useCallback)(() => {
      api(`/personal/${e}?desde=${t.desde}&hasta=${t.hasta}`)
        .then(a)
        .catch((e) => s(e.message));
    }, [e, t]);
  ((0, React.useEffect)(() => {
    y();
  }, [y]),
    (0, React.useEffect)(() => {
      api(`/unidades?todas=true`)
        .then(f)
        .catch(() => {});
    }, []));
  async function b(t) {
    (t.preventDefault(), s(``));
    try {
      (await api(`/personal/${e}/areas`, {
        method: `POST`,
        body: JSON.stringify({
          unidadId: p ? Number(p) : null,
          desde: h,
          motivo: _,
        }),
      }),
        l(!1),
        v(``),
        y(),
        r());
    } catch (e) {
      s(e.message);
    }
  }
  return (
    <Modal
      titulo={i?.nombre ?? `Ficha`}
      onClose={n}
      ancho={`max-w-2xl`}
      children={
        i ? (
          <div
            className={`flex flex-col gap-4 text-sm`}
            children={[
              <div
                className={`grid gap-3 sm:grid-cols-2`}
                children={[
                  <div
                    className={Bo}
                    children={[
                      <p
                        className={`text-xs text-(--text)`}
                        children={`Cumplimiento`}
                      />,
                      <p
                        className={`text-2xl font-medium text-(--text-h)`}
                        children={[i.cumplimiento, `%`]}
                      />,
                      <p
                        className={`text-xs text-(--text)`}
                        children={[
                          i.completadas,
                          ` de `,
                          i.asignadas,
                          ` que tenía que entregar`,
                        ]}
                      />,
                    ]}
                  />,
                  <div
                    className={Bo}
                    children={[
                      <p
                        className={`text-xs text-(--text)`}
                        children={`En fecha`}
                      />,
                      <p
                        className={`text-2xl font-medium text-(--text-h)`}
                        children={[i.puntualidad, `%`]}
                      />,
                      <p
                        className={`text-xs text-(--text)`}
                        children={
                          i.tarde > 0
                            ? `${i.tarde} tarde, ${i.diasAtrasoPromedio} días de atraso promedio`
                            : `sin entregas tarde`
                        }
                      />,
                    ]}
                  />,
                ]}
              />,
              <ul
                className={`grid gap-x-4 gap-y-1 sm:grid-cols-2`}
                children={[
                  <Componente__A_95_65
                    titulo={`Abiertas ahora`}
                    valor={i.abiertas}
                  />,
                  <Componente__A_95_65
                    titulo={`Vencidas`}
                    valor={i.vencidas}
                    alerta={i.vencidas > 0}
                  />,
                  <Componente__A_95_65
                    titulo={`Le devolvieron`}
                    valor={i.devoluciones}
                  />,
                  <Componente__A_95_65
                    titulo={`Canceladas`}
                    valor={i.canceladas}
                  />,
                  <Componente__A_95_65
                    titulo={`Prórrogas por tardanza`}
                    valor={i.prorrogasTardanza}
                  />,
                  <Componente__A_95_65
                    titulo={`Replanificaciones`}
                    valor={i.prorrogasReprogramacion}
                  />,
                  <Componente__A_95_65
                    titulo={`Esperan su visto bueno`}
                    valor={i.esperandoSuConformidad}
                  />,
                  <Componente__A_95_65
                    titulo={`De esas, demoradas`}
                    valor={i.conformidadesDemoradas}
                    alerta={i.conformidadesDemoradas > 0}
                  />,
                  <Componente__A_95_65
                    titulo={`La más vieja espera hace`}
                    valor={
                      i.esperaMasVieja == null ? `—` : `${i.esperaMasVieja} d`
                    }
                    alerta={i.esperaMasVieja >= 3}
                  />,
                  <Componente__A_95_65
                    titulo={`Aprobó en el período`}
                    valor={i.conformidadesDadas}
                  />,
                  <Componente__A_95_65
                    titulo={`Tardó en aprobar (promedio)`}
                    valor={
                      i.conformidadesDadas > 0
                        ? zx(Math.round(i.horasPromedioAprobar))
                        : `—`
                    }
                  />,
                ]}
              />,
              <div
                children={[
                  <div
                    className={`flex items-center justify-between gap-2`}
                    children={[
                      <p
                        className={`font-medium text-(--text-h)`}
                        children={`Paso por las áreas`}
                      />,
                      !c && (
                        <button
                          type={`button`}
                          onClick={() => l(!0)}
                          className={zo}
                          children={`Cambiar de área`}
                        />
                      ),
                    ]}
                  />,
                  c && (
                    <form
                      onSubmit={b}
                      className={`mt-2 flex flex-col gap-2 rounded-2xl border border-(--accent-border) bg-(--accent-bg) p-3`}
                      children={[
                        <SelectorMultiple
                          value={p}
                          onChange={m}
                          placeholder={`¿A qué área pasa?`}
                          opciones={u.map((e) => ({
                            value: String(e.id),
                            label: ZC(e.ruta || e.nombre, e),
                          }))}
                        />,
                        <div
                          className={`grid gap-2 sm:grid-cols-2`}
                          children={[
                            <SelectorFecha
                              value={h}
                              placeholder={`Desde`}
                              onChange={g}
                            />,
                            <input
                              className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg)`}
                              placeholder={`Motivo (opcional)`}
                              value={_}
                              onChange={(e) => v(e.target.value)}
                            />,
                          ]}
                        />,
                        <p
                          className={`text-xs text-(--text)`}
                          children={`Lo anterior no se toca: se cierra el tramo y queda el registro de dónde estuvo.`}
                        />,
                        <div
                          className={`flex flex-col-reverse gap-2 sm:flex-row sm:justify-end`}
                          children={[
                            <button
                              type={`button`}
                              onClick={() => l(!1)}
                              className={zo}
                              children={`Volver`}
                            />,
                            <button
                              type={`submit`}
                              className={Ro}
                              children={`Guardar`}
                            />,
                          ]}
                        />,
                      ]}
                    />
                  ),
                  <ul
                    className={`mt-2 flex flex-col gap-1`}
                    children={[
                      (i.historialAreas ?? []).map((e) => (
                        <li
                          key={e.id}
                          className={`flex flex-wrap items-baseline gap-x-2 rounded-xl border border-(--border) px-3 py-2`}
                          children={[
                            <span
                              className={`min-w-0 flex-1 truncate text-(--text-h)`}
                              title={e.area}
                              children={e.area}
                            />,
                            e.cargo && (
                              <span
                                className={`text-xs text-(--text)`}
                                children={e.cargo}
                              />
                            ),
                            <span
                              className={`text-xs text-(--text)`}
                              children={[
                                fS(e.desde),
                                ` → `,
                                e.hasta ? fS(e.hasta) : `hoy`,
                              ]}
                            />,
                            e.motivo && (
                              <span
                                className={`w-full text-xs text-(--text)`}
                                children={e.motivo}
                              />
                            ),
                          ]}
                        />
                      )),
                      (i.historialAreas ?? []).length === 0 && (
                        <li
                          className={`text-xs text-(--text)`}
                          children={`Todavía no tiene áreas registradas.`}
                        />
                      ),
                    ]}
                  />,
                ]}
              />,
              o && <p className={`text-(--error)`} children={o} />,
              <div
                className={`flex justify-end`}
                children={
                  <button
                    type={`button`}
                    onClick={n}
                    className={zo}
                    children={`Cerrar`}
                  />
                }
              />,
            ]}
          />
        ) : (
          <div
            className={`flex items-center gap-2 text-sm text-(--text)`}
            children={[
              (0, JSXRuntime.jsx)(ii, {
                className: `h-4 w-4 animate-spin`,
              }),
              ` Cargando…`,
            ]}
          />
        )
      }
    />
  );
}
